var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plus_icon",
    "data-name": "Plus icon",
    transform: "translate(-1849 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5788",
    "data-name": "Rectangle 5788",
    width: 50,
    height: 50,
    rx: 8,
    transform: "translate(1849 80)",
    fill: "#1487ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plus_1_",
    "data-name": "plus (1)",
    d: "M35.752,26.253A1.139,1.139,0,0,1,34.608,27.4H27.143v7.211a1.144,1.144,0,1,1-2.288,0V27.4H17.644a1.144,1.144,0,0,1,0-2.288h7.211V17.644a1.144,1.144,0,0,1,2.288,0v7.465h7.465A1.139,1.139,0,0,1,35.752,26.253Z",
    transform: "translate(1847.5 78.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.8cb9415be264b035c7125f81d7f053f7.svg";
export { ForwardRef as ReactComponent };